import { Component, OnInit } from '@angular/core';
import { ResetPasswordService } from './reset-password.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  wait = false;
  response = '';
  typeResponse = '';
  token: null | string = null;
  passwordNew = '';
  passwordConfirm = '';

  constructor(private resetPasswordService: ResetPasswordService, 
    private route: ActivatedRoute, 
    private router: Router, 
    private toastService: ToastrService) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    // if (!this.token) {
    //   this.router.navigate(['/login']);
    // }
  }


  submitReset() {
    if (this.passwordNew !== this.passwordConfirm) {
      this.toastService.warning("La contraseñas deben de coincidir.");
      return;
    }

    if (this.passwordNew.length <8) {
      this.toastService.warning("La contraseña deben tener minimio 8 caracteres");
      return;
    }

    this.wait = true;
    this.typeResponse = '';
    const data = {
      token: this.token,
      pass1: this.passwordNew,
      pass2: this.passwordConfirm
    }
    this.resetPasswordService.sendResetRequest(data).subscribe(
      (response)=>{
        this.typeResponse = 'info';
        this.wait = false;
        const message = Object(response)['data'].message;
        this.response = message;
        this.toastService.success("Contraseña Restablecida Correctamente");
        this.router.navigate(['authentication/login']);
      },
      (error)=>{
        this.typeResponse = 'danger';
        this.wait = false;
        const message = Object(error)['error'].message;
        this.response = message;
        this.toastService.error("No se puedo restablecer la contraseña");
      }
    )
  }

}
